import {destroy, mutate, query, update} from "../../defaults/fetch";
import {useEffect, useState} from "react";

const BASE = "staff-category"
export const useGetAllStaffCategories = () => {
    const getAllCategories = async () => {
        const url = `${BASE}/get-all`
        const {data} = await query(url)
        return data
    }

    return getAllCategories
}

export const useFetchAllStaffCategories = (flag) => {
    const [loading, setLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const getAllCategories = async () => {
        setLoading(true)
        const url = `${BASE}/get-all`
        const { data } = await query(url)
        setLoading(false)
        setCategories(data)
    }

    useEffect(() => {
        getAllCategories()
    }, [flag]);

    return {loading, categories}
}

export const useCreateStaffCategory = () => {
    const createStaffCategory = async (body) => {
        const url = `${BASE}/create`
        const {data} = mutate(url, true, body)
        return data
    }

    return createStaffCategory
}

export const useUpdateStaffCategory = () => {
    const updateStaffCategory = async (id, body) => {
        const url = `${BASE}/update/${id}`
        const {data} = update(url, body)
        return data
    }

    return updateStaffCategory
}


export const useDeleteStaffCategory = () => {
    const deleteStaffCategory = async (id) => {
        const url = `${BASE}/delete/${id}`;
        const {data} = await destroy(url);
        return data;
    }
    return deleteStaffCategory;
}
